import React, { useEffect, useState } from "react";
import Menu from "../Menu";
import DopMenu from "../dopMenu";
import { Image } from "semantic-ui-react";
import Footer from "../footer";
import RangeAmount from "../rangeSliders/RangeAmount";
import { Link } from "react-router-dom";
import MetaTags from "react-meta-tags";
import ReactGA from "react-ga";
import Rules from "./rules";

const Home = () => {
  const [isOpenInclusive, setIsOpenInclusive] = useState(false);
  const [isStickyInclusive, setIsStickyInclusive] = useState(false); // для другого хедера відступи при відритій інклюзив панелі

  useEffect(() => {
    ReactGA.pageview("/");
    // hotjar.initialize(1592041, 6);

    const header = document.querySelector(".second-block-nav");
    if (header) {
      const sticky = header.offsetTop;
      const handleScroll = () => {
        if (window.pageYOffset > sticky) {
          header.classList.add("fixed");
          setIsStickyInclusive(true);
        } else {
          header.classList.remove("fixed");
          setIsStickyInclusive(false);
        }
      };
      window.addEventListener("scroll", handleScroll);

      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);

  return (
    <div>
      <MetaTags>
        <title>
          Кредит онлайн | Отримати гроші через інтернет просто ➣ Довго Гроші
        </title>
        <meta
          name="description"
          content="Кредит онлайн на карту | Позики до 50000 грн без відмови ✅ готівкою ✨ онлайн на карту ⭐ швидко ⏰ Довго Гроші"
        />
      </MetaTags>
      <div className="first-block">
        <div className="first-block-image" id="contentfirstpage">
          <Menu
            isOpenInclusive={isOpenInclusive}
            setIsStickyInclusive={setIsStickyInclusive}
            setIsOpenInclusive={setIsOpenInclusive}
            isStickyInclusive={isStickyInclusive}
          />
          <div className="first-block-info">
            <div className="first-block-info-text">
              <div className="info-text-uppercase">
                <span>Кредит онлайн</span>
                <span>ДовгоГроші</span>
                <span>до 50 000 грн</span>
              </div>
              <div className="info-text-regular">
                <span>від партнера ШвидкоГроші</span>
              </div>
            </div>
            <div className="first-block-info-switcher">
              <RangeAmount />
              <button>
                <a
                  href="https://sgroshi.com.ua/ua?partner=dovghoghroshi&subpartner=1&utm_source=dovghoghroshi&utm_medium=vitrina&utm_term=1&utm_content=1&utm_campaign=1"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="FirsButton"
                  id="getMoneyMainPageDovgoGroshi"
                >
                  Отримати гроші
                </a>
              </button>
              <div className="rules-exc">
                Ця інформація не є кредитним калькулятором у розумінні НПА НБУ.
                Детальні розрахунки витрат на кредит з урахуванням вибраних умов
                (калькулятори по кожному кредитному продукту){" "}
                <a
                  className="rules-exc-link"
                  target="_blank"
                  rel="nofollow"
                  href="https://sgroshi.com.ua/ua/all-calc/"
                >
                  тут
                </a>
                .
                <br />
                <p className="rules-exc-par">
                  <a
                    target="_blank"
                    rel="nofollow"
                    href="https://sgroshi.com.ua/storage/app/public/docs/essential_characteristics/essential_characteristics.pdf"
                    className="rules-exc-link"
                  >
                    Істотні характеристики послуги
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="second-block">
        <DopMenu
          isStickyInclusive={isStickyInclusive}
          isOpenInclusive={isOpenInclusive}
        />
        <div className="second-block-image revealator-slideleft revealator-delay3 revealator-once">
          <div className="block-image-text">
            <span>Як</span>
            <span>Отримати</span>
            <span>Кредит</span>
          </div>

          <div className="block-image-logos">
            <div className="block-image-border"></div>

            <div className="block-image-logo">
              <Image
                src="images/laptop.svg"
                alt=""
                className="image-logo-first"
              />
              <span>1</span>
              <div className="image-logos-text logos-text-first">
                <p>Залиште</p>
                <p>заявку</p>
                <p>на сайті</p>
              </div>
            </div>

            <div className="block-image-logo">
              <Image
                src="images/phone.svg"
                alt=""
                className="image-logo-second"
              />
              <span>2</span>
              <div className="image-logos-text">
                <p>Отримайте</p>
                <p>підтвердження</p>
                <p>по телефону</p>
              </div>
            </div>

            <div className="block-image-logo">
              <Image
                src="images/money.svg"
                alt=""
                className="image-logo-third"
              />
              <span>3</span>
              <div className="image-logos-text logos-text-third">
                <p>Отримайте гроші</p>
                <p>готівкою або</p>
                <p>на картку</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="third-block revealator-slideup revealator-once">
        <div className="third-block-image" id="contentfirstpage1">
          <div className="third-block-info">
            <div className="third-block-info-text revealator-slideright revealator-delay7 revealator-once">
              <div className="block-info-text">
                <span>Переваги</span>
                <span>Співробітництва</span>
                <span>З нами:</span>
                <button>
                  <a
                    href="https://sgroshi.com.ua/kabinet/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Отримати гроші
                  </a>
                </button>
              </div>

              <div className="block-info-logos">
                <div className="block-info-logo">
                  <Image src="images/simple.svg" alt="" />

                  <p>Просто</p>

                  <div className="info-logo-text">
                    <p>
                      Прості умови без прихованих комісій та додаткових платежів
                    </p>
                  </div>
                </div>

                <div className="block-info-logos-col-row">
                  <div className="block-info-logo">
                    <Image src="./images/safety.svg" alt="" />

                    <p>Надійно</p>

                    <div className="info-logo-text">
                      <p>
                        Наші клієнти рекомендують нас своїм друзям та родичам
                      </p>
                    </div>
                  </div>
                  <div className="block-info-logo">
                    <Image src="images/quick.svg" alt="" />
                    <p>Швидко</p>
                    <div className="info-logo-text">
                      <p>
                        Отримати гроші або оплатити кредит можна протягом
                        декількох хвилин
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="rules-info-container-scroll">
        <h4 className="rules-home-header">Розкриття інформації</h4>
        <div className="rules-block-content">
          <Rules hideFooterAndHeader={true} />
        </div>
      </div>
      <div className="fourth-block">
        <div className="fourth-block-info revealator-slideup revealator-once">
          <div className="fourth-block-info-text-left">
            <span>Умови</span>
            <span>Простого</span>
            <span>Кредиту</span>
          </div>
          <div className="fourth-block-info-text-right">
            <h1 className="infoTitle">
              Кредит онлайн на картку в Україні від НаДовго
            </h1>
            <p>
              Шукаєте надійний <b>онлайн кредит в Україні? НаДовго</b> – це ваша
              онлайн фінансова платформа, де можна безпечно оформити онлайн
              позику на картку. Наша діяльність як{" "}
              <b>фінансової компанії з ліцензією НБУ</b> є вашою головною
              гарантією безпеки та прозорості умов.
            </p>

            <h2 className="infoTitle">
              Як отримати онлайн кредит за 15 хвилин
            </h2>

            <ol className="InfoTextList">
              <li>
                <b>Подайте заявку онлайн:</b> Скористайтесь нашим кредитним
                калькулятором, щоб обрати суму та строк. Заповніть коротку
                анкету, маючи при собі лише паспорт та РНОКПП (ІПН).
              </li>
              <li>
                <b>Отримайте рішення:</b> Наша автоматизована система аналізує
                заявку та надає рішення в середньому за 15 хвилин.
              </li>
              <li>
                <b>Отримайте гроші:</b> Після підписання договору гроші на
                картку миттєво зараховуються на ваш рахунок.
              </li>
            </ol>

            <p>
              <b>Оформіть просто зараз — гроші сьогодні на вашій картці.</b>
            </p>

            <h2 className="infoTitle">Умови наших кредитних продуктів</h2>
            <p>
              Ми пропонуємо два основні напрямки кредитування, щоб ви могли
              обрати оптимальний варіант для себе.
            </p>

            <h3 className="infoTitle">
              Кредитний продукт «Гроші в розстрочку» (споживчий кредит)
            </h3>
            <p>
              Цей тип кредиту призначений для більших сум від 3 000 до 50 000
              грн з поступовим погашенням та максимальною РРПС до 11 016,79%.
            </p>

            <h3 className="infoTitle">
              Кредитний продукт «Гроші до зарплати» (споживчі кредити та швидкі
              позики){" "}
            </h3>
            <p>
              Ідеальне рішення для покриття невідкладних потреб на суму від 500
              до 50 000 грн з максимальною РРПС до 6 415%.
            </p>

            <h2 className="infoTitle">
              Розрахуйте ваш кредит – повна прозорість до підписання договору
            </h2>
            <p>
              Перш ніж приймати рішення, ми наполегливо рекомендуємо
              скористатися нашим офіційним інструментом - калькулятором
              розрахунку. Це дозволить вам побачити точну суму до повернення,
              включаючи всі відсотки та комісії, для будь-якого з наших
              продуктів.
            </p>

            <div className="infoLinkBtnRow">
              <a
                href="https://sgroshi.com.ua/all-calc/"
                rel="nofollow"
                target="_blank"
              >
                Розрахувати кредит
              </a>
            </div>

            <h2 className="infoTitle">
              Юридичні гарантії та абсолютна прозорість
            </h2>
            <p>
              <b>НаДовго</b> – це торгова марка, що представляє{" "}
              <b>ТОВ «Споживчий Центр»</b> – спеціалізовану фінансову компанію,
              яка діє виключно в правовому полі України.
            </p>

            <ul className="InfoTextList">
              <li>
                <b>Повне найменування:</b> Товариство з обмеженою
                відповідальністю «Споживчий центр».
              </li>
              <li>
                <b>Ідентифікаційний код (ЄДРПОУ):</b> 37356833.
              </li>
              <li>
                <b>Ліцензія:</b> Наша діяльність здійснюється на основі{" "}
                <b>
                  ліцензії на діяльність фінансової компанії з правом надання
                  послуги – надання коштів та банківських металів у кредит,
                </b>{" "}
                переоформленої <b>07.03.2024р. Національним банком України.</b>
              </li>
            </ul>

            <h3 className="infoTitle">Як перевірити ліцензію кредитора</h3>
            <p>
              Статус нашої ліцензії – <b>чинна</b>. Ви можете перевірити це в
              будь-який момент в офіційному державному реєстрі за{" "}
              <a
                href="https://kis.bank.gov.ua/search-fu"
                target="_blank"
                rel="nofollow"
              >
                посиланням → Перевірити статус ліцензії
              </a>
              .
            </p>

            <h3 className="infoTitle">Фінансова звітність та документація</h3>
            <p>
              Ми забезпечуємо повну прозорість нашої діяльності. Ознайомтесь з
              нашою фінансовою звітністю, висновками незалежних аудиторів, а
              також з основними{" "}
              <a
                href="https://sgroshi.com.ua/credit/"
                target="_blank"
                rel="nofollow"
              >
                Правилами надання кредитів
              </a>{" "}
              та{" "}
              <a
                href="https://sgroshi.com.ua/ua/rozkritta-informacii/"
                target="_blank"
                rel="nofollow"
              >
                додатковою інформацією → Документація компанії
              </a>
              .
            </p>

            <h2 className="infoTitle">
              Повний перелік кредитних продуктів від НаДовго
            </h2>
            <ul className="InfoTextList">
              <li>Гроші до зарплати (мікрокредити)</li>
              <li>Гроші до зарплати (без застави)</li>
              <li>Гроші до зарплати – промо (мікрокредити)</li>
              <li>Гроші до зарплати – промо (без застави)</li>
              <li>Гроші в розстрочку (ставка 1% за день) (без застави)</li>
              <li>Гроші в розстрочку (ставка 0,85% за день) (без застави)</li>
              <li>
                Гроші до зарплати (мікрокредит) «Кредит -0,01%» (Акційний)
              </li>
              <li>
                Гроші до зарплати «Кредит -0,01%» (Акційний) (без застави)
              </li>
            </ul>

            <h2 className="infoTitle">Розрахунок вартості онлайн кредиту</h2>
            <p>
              (Приклад розрахунку по споживчому кредиту Гроші в розстрочку
              (ставка 1% за день) (без застави)): при сумі кредиту в 3 000 грн.,
              на строк 98 днів, процентна ставка 1% в день, комісія, пов'язана з
              наданням Кредиту 20% від суми наданого кредиту - проценти за
              користування коштами складуть за весь строк кредитування 2120,51
              грн., комісія складає 600 грн., денна процентна ставка [ДПС] =
              ([ЗВСК]/[ЗРК])/[t] × 100%=(2120,51+600)/3 000/98× 100%=0,93%.
              Кредит погашається частинами - рівними платежами у розмірі 817,22
              грн. кожні 14 днів. Для наведеного розрахунку - максимальний строк
              кредитування 98 днів, мінімальний строк кредитування 98 днів.
            </p>

            <h2 className="infoTitle">
              Попередження про наслідки: Ваша фінансова відповідальність
            </h2>

            <div className="warning-attention">
              <div>
                <p>
                  Наслідками укладення кредитного договору та користування
                  споживчим кредитом є виникнення зобов’язань споживача за цим
                  кредитним договором, зокрема, зобов’язання повернути кредит та
                  сплатити платежі за договором; наслідками
                  невиконання/неналежного виконання споживачем будь-яких
                  грошових зобов’язань за договором про споживчий кредит є
                  настання відповідальності споживача за невиконання
                  зобов’язання, встановленої договором та/або законом, зокрема,
                  позичальник зобов’язаний сплатити кредитодавцю суму
                  заборгованості з урахуванням відсотків річних від суми
                  заборгованості (розмір відсотків річних відрізняється в
                  залежності від умов кожного конкретного кредитного договору та
                  встановлюється в конкретному договорі) за весь час
                  прострочення відповідно до ст.625 Цивільного кодексу України.
                  Кредитодавець має право нараховувати вказані відсотки річних,
                  починаючи з першого дня прострочення виконання зобов`язання (в
                  тому числі, якщо прострочення виконання виникло до закінчення
                  строку, на який надається кредит) за кожен день прострочення
                  його виконання. Базою нарахування вказаних відсотків є сума
                  простроченого грошового зобов’язання, зокрема, сума
                  прострочених кредиту/його частини та/або процентів/їх частини
                  та/або комісії(їй)/ її(їх) частини (якщо комісія (ії)
                  встановлена(і) договором). Відсотки річних не нараховуються на
                  прострочені раніше нараховані відсотки річних. При цьому
                  сукупна сума процентів річних та інших платежів, що підлягають
                  сплаті позичальником за порушення виконання його зобов'язань
                  (якщо такі встановлені договором) на підставі даного договору,
                  не може перевищувати максимальне обмеження цієї суми,
                  встановленої законом.
                </p>
              </div>
            </div>

            <hr className="infoDevider" />

            <h2 className="infoTitle">
              FAQ: Питання та відповіді по кредитам онлайн в Україні
            </h2>

            <h3 className="infoTitle">
              <b>З якого віку можна отримати онлайн позику на картку?</b> <br />
              <span>
                Наша онлайн позика на картку доступна для всіх повнолітніх
                громадян України віком від 18 років.
              </span>
            </h3>

            <h3 className="infoTitle">
              <b>Які мої права як позичальника захищені законом?</b> <br />
              <span>
                Ваші права захищені Законом України «Про споживче кредитування».
                Норми цього Закону надають вам право відмовитися від кредитного
                договору без пояснення причин протягом 14 календарних днів з
                моменту його укладення. Робота під наглядом НБУ є додатковою
                гарантією дотримання цих норм.
              </span>
            </h3>
          </div>
        </div>
      </div>
      <Footer
        isOpenInclusive={isOpenInclusive}
        setIsOpenInclusive={setIsOpenInclusive}
      />
    </div>
  );
};

export default Home;



// WEBPACK FOOTER //
// src/pages/home.js